<template>
  <div>
    <p class="font-nunito text-weight-bolder primary-text">{{ label }}</p>
    <div class="weekly-budget">
      <div class="md:w-90 md:m-auto">
        <QRange v-model="selectedValue" :min="min" :max="max" :step="step" :marker-labels="markerLabel" :disable="disabled" />
      </div>
      <QIcon :name="closeIcon" class="q-field__marginal" size="20px" @click="close" v-if="this.selectedValue.min !== null"></QIcon>
    </div>
  </div>
</template>
<script>
import { QRange, QIcon } from 'quasar';
import { evaCloseCircleOutline } from '@quasar/extras/eva-icons';
export default {
  props: {
    value: {
      default: () => {
        return {
          min: null,
          max: 100
        };
      }
    },
    label: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: 100
    },
    max: {
      type: Number,
      default: 1000
    },
    step: {
      type: Number,
      default: 100
    },
    markerLabel: {
      default: function () {
        return [];
      },
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'RangeSelector',
  components: { QRange, QIcon },
  data: function () {
    return {
      selectedValue: {},
      closeIcon: evaCloseCircleOutline
    };
  },
  created() {
    this.selectedValue = this.value;
  },
  watch: {
    selectedValue(newSelectedValue) {
      this.$emit('input', { ...newSelectedValue });
    }
  },
  methods: {
    close() {
      const newSelectedValue = {
        min: null,
        max: this.min
      };
      this.selectedValue = { ...newSelectedValue };
      this.$emit('input', { ...newSelectedValue });
    }
  }
};
</script>
<style lang="sass" scoped>
.weekly-budget
  position: relative
  box-sizing: border-box
  .q-icon
    position: absolute
    top: -6px
    right: 0px
  font-size: 11px

// Below md breakpoint, width/margin helpers are off — full-bleed QRange makes marker labels clip. Inset slightly.
@media screen and (max-width: 767px)
  .weekly-budget
    padding-left: 14px
    padding-right: 14px

@media screen and (min-width: 768px)
  .weekly-budget
    padding-left: 0
    padding-right: 0
  .md\:w-90
    width: 90%
  .md\:m-auto
    margin-left: calc(5% - 7px)
</style>
